<template>
	<div></div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	async created() {
		//test Data
		//home 이동
		//localhost:8081/ssoLogin?token=eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJtSDVpbHJvTEhzUkVORkh1THYwYjBPbzMyY0lyZXpnT1NiUVdicUhpYTI4In0.eyJleHAiOjE2Mzg0MTgzNTksImlhdCI6MTYzODQxMTE1OSwianRpIjoiZWQ1MTRmNTQtYTk0YS00YjRiLThmYWEtNzk3NGQyMDI1MWUwIiwiaXNzIjoiaHR0cHM6Ly9kZXYtc3NvLmNsb3VkLmh5dW5kYWktYXV0b2V2ZXIuY29tL2F1dGgvcmVhbG1zL0hDUCIsImF1ZCI6WyJoY3AtcG9ydGFsIiwiYWNjb3VudCJdLCJzdWIiOiI2MTk1OGQ3Yi01ZWE3LTQ3YzYtYjcyYy04Y2U2OWIxYzMzMDMiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJoY3AtcG9ydGFsIiwic2Vzc2lvbl9zdGF0ZSI6IjkwODNhMmE0LWQ1OTctNDliNC05NWRlLThiOWZlYjU5NjQ4YyIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiKiIsImh0dHBzOi8vZGV2LmNsb3VkLmh5dW5kYWktYXV0b2V2ZXIuY29tIiwiaHR0cHM6Ly9kZXYtY2QuY2xvdWQuaHl1bmRhaS1hdXRvZXZlci5jb20iLCJodHRwczovL2Rldi1yZWdpc3RyeS5jbG91ZC5oeXVuZGFpLWF1dG9ldmVyLmNvbSIsImh0dHA6Ly9sb2NhbGhvc3Q6MzAwMCJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiREVGQVVMVC1NRU1CRVIiLCJvZmZsaW5lX2FjY2VzcyIsInVtYV9hdXRob3JpemF0aW9uIiwiQ09NUEFOWS1NRU1CRVIiXX0sInJlc291cmNlX2FjY2VzcyI6eyJhY2NvdW50Ijp7InJvbGVzIjpbIm1hbmFnZS1hY2NvdW50IiwibWFuYWdlLWFjY291bnQtbGlua3MiLCJ2aWV3LXByb2ZpbGUiXX19LCJzY29wZSI6Im9wZW5pZCBkaXNwbGF5TmFtZSBkZXBhcnRtZW50IGFwcC1hdWRpZW5jZSBncm91cHMgcHJvZmlsZSBjb21wYW55IGVtYWlsIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJkaXNwbGF5TmFtZSI6Iuq5gOyasOyglSDssYXsnoQiLCJuYW1lIjoiSDE5OTAwMTEyNTU1NyDquYDsmrDsoJUg7LGF7J6EIiwiZ3JvdXBzIjpbIi9IMTk5IiwiL0RFRkFVTFQtR1JPVVAiXSwiY29tcGFueSI6IkgxOTk77ZiE64yA7Jik7Yag7JeQ67KEIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiaDE5OTAwMTEyNTU1NyIsImRlcGFydG1lbnQiOiJIMTk5RTczMDc7U0bquLDsiKAx7YyAIiwiZ2l2ZW5fbmFtZSI6IkgxOTkwMDExMjU1NTciLCJmYW1pbHlfbmFtZSI6Iuq5gOyasOyglSDssYXsnoQiLCJlbWFpbCI6IndqLmtpbUBoeXVuZGFpLWF1dG9ldmVyLmNvbSJ9.DzmxFcUUMAkiYg19GfL2XnAQ_ZqO5Ue3bYNDEsVH2o0OFhKd3w4pVb4XpYXCwbbfu0Ntd03Luq_RdSnVEy9CEgVAL825k8fqRvrmOJdPSj4YSdEUNj8SOoftHEExNYZe9Rold5MZw24Yeyfm_5gr5GPmlWTBMGKHtInqTuw26horadPRE4SG-_GDU8yo_sjtXmPGxLp4z9_o6BVlSRnMEZRpQUl0DzSy7i4fNju-pfwOX7QK1yHHdYMumaglm1UEgniJAR06i9d0z9E-l0DWwvD7WbYJ5NqRImyPk4AsOQ3tlVuDANgZMxqK8W5a6GBxLlu5SmQbhk_CXgD3fwmhPQ&langCd=en_US&scrId=S00001095
		//단일 페이지 이동
		//localhost:8081/ssoLogin?token=eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJtSDVpbHJvTEhzUkVORkh1THYwYjBPbzMyY0lyZXpnT1NiUVdicUhpYTI4In0.eyJleHAiOjE2Mzg0MTgzNTksImlhdCI6MTYzODQxMTE1OSwianRpIjoiZWQ1MTRmNTQtYTk0YS00YjRiLThmYWEtNzk3NGQyMDI1MWUwIiwiaXNzIjoiaHR0cHM6Ly9kZXYtc3NvLmNsb3VkLmh5dW5kYWktYXV0b2V2ZXIuY29tL2F1dGgvcmVhbG1zL0hDUCIsImF1ZCI6WyJoY3AtcG9ydGFsIiwiYWNjb3VudCJdLCJzdWIiOiI2MTk1OGQ3Yi01ZWE3LTQ3YzYtYjcyYy04Y2U2OWIxYzMzMDMiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJoY3AtcG9ydGFsIiwic2Vzc2lvbl9zdGF0ZSI6IjkwODNhMmE0LWQ1OTctNDliNC05NWRlLThiOWZlYjU5NjQ4YyIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiKiIsImh0dHBzOi8vZGV2LmNsb3VkLmh5dW5kYWktYXV0b2V2ZXIuY29tIiwiaHR0cHM6Ly9kZXYtY2QuY2xvdWQuaHl1bmRhaS1hdXRvZXZlci5jb20iLCJodHRwczovL2Rldi1yZWdpc3RyeS5jbG91ZC5oeXVuZGFpLWF1dG9ldmVyLmNvbSIsImh0dHA6Ly9sb2NhbGhvc3Q6MzAwMCJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiREVGQVVMVC1NRU1CRVIiLCJvZmZsaW5lX2FjY2VzcyIsInVtYV9hdXRob3JpemF0aW9uIiwiQ09NUEFOWS1NRU1CRVIiXX0sInJlc291cmNlX2FjY2VzcyI6eyJhY2NvdW50Ijp7InJvbGVzIjpbIm1hbmFnZS1hY2NvdW50IiwibWFuYWdlLWFjY291bnQtbGlua3MiLCJ2aWV3LXByb2ZpbGUiXX19LCJzY29wZSI6Im9wZW5pZCBkaXNwbGF5TmFtZSBkZXBhcnRtZW50IGFwcC1hdWRpZW5jZSBncm91cHMgcHJvZmlsZSBjb21wYW55IGVtYWlsIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJkaXNwbGF5TmFtZSI6Iuq5gOyasOyglSDssYXsnoQiLCJuYW1lIjoiSDE5OTAwMTEyNTU1NyDquYDsmrDsoJUg7LGF7J6EIiwiZ3JvdXBzIjpbIi9IMTk5IiwiL0RFRkFVTFQtR1JPVVAiXSwiY29tcGFueSI6IkgxOTk77ZiE64yA7Jik7Yag7JeQ67KEIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiaDE5OTAwMTEyNTU1NyIsImRlcGFydG1lbnQiOiJIMTk5RTczMDc7U0bquLDsiKAx7YyAIiwiZ2l2ZW5fbmFtZSI6IkgxOTkwMDExMjU1NTciLCJmYW1pbHlfbmFtZSI6Iuq5gOyasOyglSDssYXsnoQiLCJlbWFpbCI6IndqLmtpbUBoeXVuZGFpLWF1dG9ldmVyLmNvbSJ9.DzmxFcUUMAkiYg19GfL2XnAQ_ZqO5Ue3bYNDEsVH2o0OFhKd3w4pVb4XpYXCwbbfu0Ntd03Luq_RdSnVEy9CEgVAL825k8fqRvrmOJdPSj4YSdEUNj8SOoftHEExNYZe9Rold5MZw24Yeyfm_5gr5GPmlWTBMGKHtInqTuw26horadPRE4SG-_GDU8yo_sjtXmPGxLp4z9_o6BVlSRnMEZRpQUl0DzSy7i4fNju-pfwOX7QK1yHHdYMumaglm1UEgniJAR06i9d0z9E-l0DWwvD7WbYJ5NqRImyPk4AsOQ3tlVuDANgZMxqK8W5a6GBxLlu5SmQbhk_CXgD3fwmhPQ&langCd=en_US&scrId=
		//

		//SMP-ICON Redirect login 경우 자동 로그인 처리
		const query = this.$route.query;

		//query String에서 data 추출
		if (!this.$sf_isEmptyObj(query)) {
			let { token, langCd, scrId } = query;
			//home 화면 이동, 에러메세지 처리를 위한 다국어 호출
			await this.getLangMessage(langCd);
			//다국어 셋팅 완료 후 SSO Login 호출
			await this.ssoLogin(token, langCd, scrId);
		} else {
			this.$sf_toast({ type: 'error', message: 'Access URL Error' });
		}
	},
	computed: {
		...rootComputed
	},

	methods: {
		...rootMethods,

		//SSO Login 호출
		ssoLogin(token, langCd, scrId) {
			this.$sf_toggleLoading(true);

			this.ssoLogin_({ token, langCd, scrId })
				.then(header => {
					//실패 시에만 에러 toast 창 알림
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					} else {
						//scrId 이 없을경우 redirectUrl=null로 응답이 옴
						//이 경우는 home 화면으로 이동(Route 방식으로 로그인/사용자 정보 유지)
						if (!header.redirectUrl) {
							this.$router.push(this.homeUrl).catch(() => {}); //home 화면 이동
						}
						//redirectUrl이 있으면
						else {
							//해당 URL로 redirect
							window.location.href = header.redirectUrl;
						}
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//query String의 언어 정보를 이용해 다국어 리스트 요청
		getLangMessage(langCd) {
			this.$sf_toggleLoading(true);

			//다국어 리스트를 요청하는 Action 호출
			this.getLangMessage_({ langCd })
				.then(header => {
					//실패 시에만 에러 toast 창 알림
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					//302 에러로 인해 에러창이 발생하여, 임시로 주석처리 함
					// this.$sf_toast({
					// 	type: 'error',
					// 	message: error.message
					// });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
<style></style>
